export default __webpack_public_path__ + "static/media/Fidelity-Computer-Crime-insurance-policy-2025.6ed20ed8.pdf";